/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const PlaceOrderPropTypes = {
  /**
   * actions to use
   */
  actions: PropTypes.object,

  /**
   * History object
   */
  history: PropTypes.object,

  /**
   * User info
   */
  userInfo: PropTypes.object,

  /**
   * Current account
   */
  currentAccountGlobal: PropTypes.string,

  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The width of viewport
   */
  width: PropTypes.string,

  /**
   * Services
   */
  services: PropTypes.object,
};

export default PlaceOrderPropTypes;
